module.exports = __webpack_public_path__ + "static/card_homepage_twitter-bc9e9d9aef89745c40831ca32cea2cf1.jpg";